<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="personal" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">
            <personal pageType="certification"></personal>
            <div class="personal_right">
              <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign6.png"> 法人认证</span></h2>
              <div style="margin-top: 50px;margin-left: 150px;">
              <el-form  :rules="rules" :model="legalObj" label-width="200px" ref="legalObj" style="width: 550px;">
                <el-form-item  label="企业营业执照"  prop="businessLicenseId">
                <div   v-if="!canEdit">
                        <el-upload
                          class="avatar-uploader"
                          list-type="picture"
                          action=""
                          :show-file-list="false"
                          :http-request="afterReadOne"
                          v-loading="loading"
                          element-loading-text="文件上传中.."
                          element-loading-spinner="el-icon-loading"
                          element-loading-background="rgba(0, 0, 0, 0.8)"
                        >
                          <img v-if="idcard_pic_front_img" :src="idcard_pic_front_img" class="avatar" style="width:270px;height: 170px;">
                          <img  v-else src="../../../static/images/fr_yyzz.jpg" style="width:270px;height: 170px;">
                        </el-upload>
                      </div>
                      <div style="width:270px;height: 170px;" v-if="canEdit">
                        <el-image
                          style="width:270px;height: 170px;"
                          :src="idcard_pic_front_img"
                          fit="fit"></el-image>
                        <!--<img v-if="idcard_pic_back_img" :src="idcard_pic_back_img"  style="width:180px;height: 127px;">-->
                      </div>
                  <el-input style="display: none" v-model="legalObj.businessLicenseId" placeholder="请上传营业执照" maxlength="30"  ></el-input>
                </el-form-item>
                      <el-form-item  label="统一社会信用代码" prop="idcardNum"  >
                        <el-input v-model="legalObj.idcardNum" :readonly="true" placeholder="请输入统一社会信用代码" maxlength="18"  ></el-input>
                      </el-form-item>
                      <el-form-item  label="公司名称" prop="companyName">
                        <el-input v-model="legalObj.companyName" placeholder="请输入公司名称" :readonly="canEdit" maxlength="30"  ></el-input>
                      </el-form-item>

                      <el-form-item  label="法人代表姓名" prop="legalName">
                        <el-input v-model="legalObj.legalName" placeholder="请输入法人代表姓名" :readonly="canEdit"  maxlength="30"  ></el-input>
                      </el-form-item>
                      <el-form-item  label="法人代表身份证号" prop="legalIdcardNum">
                        <el-input v-model="legalObj.legalIdcardNum" placeholder="请输入法人代表身份证号" :readonly="canEdit"  maxlength="18"   ></el-input>
                      </el-form-item>
                      <el-form-item  label="法人代表电话" prop="legalMobile">
                        <el-input v-model="legalObj.legalMobile" placeholder="请输入法人电话" :readonly="canEdit"  maxlength="11"  ></el-input>
                      </el-form-item>
                      <el-form-item label="法人类型" prop="legalType" >
                        <el-select v-model="legalObj.legalType" placeholder="请选择法人类型" :disabled="canEdit"  >
                          <el-option label="企业法人" value="C01"></el-option>
                          <el-option label="个体工商户" value="C02"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item  label="公司联系人" prop="linkPersion">
                        <el-input v-model="legalObj.linkPersion" placeholder="请输入公司联系人" :readonly="canEdit"  maxlength="30" ></el-input>
                      </el-form-item>
                      <el-form-item  label="公司联系电话" prop="linkPhone">
                        <el-input v-model="legalObj.linkPhone" placeholder="请输入公司联系电话" :readonly="canEdit"  maxlength="11"  ></el-input>
                      </el-form-item>
                      <el-form-item  label="公司联系地址" prop="unitAddress">
                        <el-input v-model="legalObj.unitAddress" placeholder="请输入公司联系地址" :readonly="canEdit"  maxlength="50"  ></el-input>
                      </el-form-item>
              </el-form>
                <dl class="safe" style="padding-top: 5px;padding-left: 13%;">
                  <dd class="safe_button"  ><button @click="userReg('legalObj')" :disabled="isDisabled">{{butText}}</button></dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../../components/Headers";
import fixedDiv from "../../components/FixedDiv";
import footers from "../../components/Footer";
import personal from "../../components/Personal";
export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers,personal
  },
  data() {
    let _self=this;
    return {
      active: 'guideIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      idcard_pic_front:"",
      idcard_pic_front_img:'',
      loginShow:false,
      gotoIndex:false,
      butText:'提交认证',
      canEdit:false,
      rules:{
        companyName:[{required:true,message:'请输入公司名称',tigger:'blur'}],
        legalName:[{required:true,message:'请输入法人代表姓名',tigger:'blur'}],
        linkPhone:[{required:true,message:'请输入公司联系电话',tigger:'blur'},{required:true,pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,message:'请输入正确的手机号码',tigger:'blur'}],
        legalType:[{required:true,message:'请输入选择法人类型',tigger:'change'}],
        legalAddress:[{required:true,message:'请输入法人代表地址',tigger:'blur'}],
        idcardNum:[{required:true,message:'请输入统一社会信用代码',tigger:'blur'}],
        linkPersion:[{required:true,message:'请输入企业联系人',tigger:'blur'}],
        legalIdcardNum:[{required:true,validator:this.checkUid,message:'请输入法人代表身份证',tigger:'blur'}],
        legalMobile:[{required:true,message:'请输入法人代表电话',tigger:'blur'},{required:true,pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,message:'请输入正确的手机号码',tigger:'blur'}],
        unitAddress:[{required:true,message:'请输入公司地址',tigger:'blur'}],
        businessLicenseId:[{required:true,message:'请上传营业执照',tigger:'blur'}]
      },
      isDisabled:false,
      legalPerson:false,
      loading:false,
      legalObj:{
       companyId:"",
       companyName:"",
       legalName:"",
       linkPhone:"",
       legalType:"",
       legalAddress:"",
       idcardNum:"",
       linkPersion:"",
       level:"",
       idcardType:"",
       enterpriseState:"",
       legalIdcardNum:"",
       legalMobile:"",
       userIdCode:'',
       unitAddress:'',
       businessLicenseId:'',
      }
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  },
  beforeCreate(){
    //初始化数据，判断是否已经认证
    this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
      if (response.status === 200 && response.data.code===200) {
        if(response.data.data.legalData){
          this.legalObj=response.data.data.legalData;
        if(response.data.data.legalPerson !=0){
          this.legalPerson=true;
          this.butText="重新认证";
          this.canEdit=true;
          // this.isShow=true;
        }
        if(this.legalObj.businessLicenseId){
          this.idcard_pic_front_img=this.getImg(this.legalObj.businessLicenseId);
        }
      }
      }
    })
  },
  created(){
    var userInfo=this.$cookies.get('userInfo')
    if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
      this.loginShow=true;
      this.gotoIndex=false;
    }
  },
  mounted(){
  },
  methods: {
    getImg(imgId){
      var dd=this.$util.req.getshowImg(imgId);
      return dd;
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },
    afterReadOne(files){
      if(files){
        this.isShow=false;
        files.status = 'uploading';
        files.message = '上传中...';
        files.type='FJ_2_BUSINESS_LICENSE_PIC';
        files.attrName="fj_2_blp_"+this.$util.uuid.uuid2();
        this.loading=true;
        // this.idcard_pic_front_img='';
        // this.idcard_pic_front='';
        this.compressImg(files);
        // this.afterReadFile(files);
      }
    },
    compressImg(file) {
      var t=this;
      if(/\/(?:jpeg|png)/i.test(file.file.type)&&file.file.size>2097152) {
        this.photoCompress(file,{
          quality: 0.5
        },function (base64Codes) {
          var bl = t.convertBase64UrlToBlob(base64Codes);
          let bytes=atob(base64Codes.split(',')[1]);        //去掉url的头，并转换为byte
          //处理异常,将ascii码小于0的转换为大于0
          let ab = new ArrayBuffer(bytes.length);
          let ia = new Uint8Array(ab);
          for (let i = 0; i < bytes.length; i++) {
            ia[i] = bytes.charCodeAt(i);
          }
          let fileItem = new File([ab],new Date().getTime()+'.jpg',{type:'image/jpg'});
          if(fileItem){
            file.file=fileItem;
            t.afterReadFile(file);
          }
        })
      }else{
        this.afterReadFile(file);
      }
    },
    /**
     * @param file: 上传的图片
     * @param objCompressed：压缩后的图片规格
     * @param objDiv：容器或回调函数
     */
    photoCompress(file, objCompressed, objDiv){
      var ready=new FileReader();
      ready.readAsDataURL(file.file);
      var tt=this;
      ready.onload=function(){
        var fileResult=this.result;
        tt.canvasDataURL(fileResult,objCompressed,objDiv)
      }
    },

    canvasDataURL(path, objCompressed, callback) {
      var img = new Image();
      img.src = path;
      img.onload = function () {
        var that = this;
        //默认压缩后图片规格
        var quality = 0.5;
        var w = that.width;
        var h = that.height;
        var scale = w / h;
        //实际要求
        w = objCompressed.width || w;
        h = objCompressed.height || (w / scale);
        if(objCompressed.quality && objCompressed.quality > 0 && objCompressed.quality <= 1){
          quality = objCompressed.quality;
        }
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // 创建属性节点
        var anw = document.createAttribute("width");
        anw.nodeValue = w;
        var anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);

        var base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回base64的值
        callback(base64);
      }
    },

    convertBase64UrlToBlob(urlData) {
      var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type:mime});
    },
    afterReadFile(file){
      file.status='uploading';

      let formData = new FormData;
      formData.append('_sk','app');
      formData.append('upload',file.file);
      formData.append('type',file.type);
      formData.append('attachName',"fj_2_blp_"+this.$util.uuid.uuid2());
      var ttt=this;
      this.$https.postFile('attach/upload.do',formData,(response)=>{
        if (response.status===200&&response.data.isOk){
          // file.attachId=response.data.bean.attach_id;
            ttt.idcard_pic_front_img=ttt.getImg(response.data.bean.attach_id);
            ttt.legalObj.businessLicenseId=response.data.bean.attach_id;
             file.status='done'

        }else {
          file.status='failed';
          ttt.$message({
            message: '营业执照上传失败，请重新上传',
            type: 'error'
          });
        }
        ttt.loading=false;
      });
      //重新验证表单项
      // this.$refs['photo'].resetValidation();
    },
    checkUid(rule,value,callback){
      callback(this.$util.func.uid.check(value))
    },
    userReg(formName) {
      if(this.canEdit){
        this.butText="提交认证";
        this.canEdit=false;
        return;
      }
      var ttt=this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          ttt.isDisabled=true;
          //从服务器获取code请求路径snsapi_base静默，snsapi_userinfo用户授权
          ttt.$https.post("api/pu/peopleLegalCertification.do",ttt.legalObj,response=>{
            if (response.status === 200 && response.data.code===200) {
              //弹框成功提示，并返回登录页面
              var userInfo=ttt.$cookies.get('userInfo');
              userInfo.userName=ttt.legalObj.companyName;
              ttt.$cookies.set('userInfo',userInfo);
              ttt.$message({
                message: '实名认证成功！',
                type: 'success',
                offset:250,
                duration:2500,
                onClose:function(){
                  ttt.$router.back()
                }
              });
            } else {
              ttt.isDisabled=false;
              //短信校验码错误
              ttt.$message({
                message: '实名认证失败，请检查信息是否正确！',
                type: 'success',
                offset:250,
                duration:2500,
              });
              return;
            }
          })
        }
      });
    },
  }
}



</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/personal/LegalCertification.vue